import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { httpAction, getAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
import { queryFactorList } from '@/api/api';
import LoadPrinting from "./LoadPrinting";
var paramColumns = [{
  title: '参数名称',
  dataIndex: 'name',
  align: 'center',
  width: '30%'
}, {
  title: '参数值',
  dataIndex: 'remark',
  align: 'center',
  width: '40%'
}, {
  title: '单位',
  dataIndex: 'unit_dictText',
  align: 'center',
  width: '40%'
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%'
}];
var stateColumns = [{
  title: '错误类别',
  dataIndex: 'category_dictText',
  align: 'center',
  width: '15%'
}, {
  title: '错误码',
  dataIndex: 'code',
  align: 'center',
  width: '10%'
}, {
  title: '名称',
  dataIndex: 'name',
  align: 'center',
  width: '10%'
}, {
  title: '可能原因',
  dataIndex: 'causes',
  align: 'center',
  width: '20%'
}, {
  title: '解决方案',
  dataIndex: 'solution',
  align: 'center',
  width: '25%'
}, {
  title: '排序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%'
}];
var partColumns = [{
  title: '配件类型',
  dataIndex: 'category_dictText',
  align: 'center',
  width: '20%'
}, {
  title: '配件名称',
  dataIndex: 'name',
  align: 'center',
  width: '20%'
}, {
  title: '配件说明',
  align: 'center',
  dataIndex: 'remark',
  width: '35%'
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%'
}];
var factorColumns = [{
  title: '监测因子',
  dataIndex: 'factorId',
  align: 'center',
  width: '25%',
  scopedSlots: {
    customRender: 'factorId'
  }
}, {
  title: '检出限',
  dataIndex: 'detection',
  align: 'center',
  width: '15%'
}, {
  title: '标准下限',
  dataIndex: 'lower',
  width: '15%',
  align: 'center'
}, {
  title: '标准上限',
  align: 'center',
  dataIndex: 'upper',
  width: '15%'
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%'
}];
var productColumns = [{
  title: '产品名称',
  dataIndex: 'relatedId',
  align: 'center',
  width: '30%',
  scopedSlots: {
    customRender: 'relatedId'
  }
}, {
  title: '含量',
  dataIndex: 'dosage',
  align: 'center',
  width: '40%',
  scopedSlots: {
    customRender: 'dosage'
  }
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}];
var logColumns = [{
  title: '事件类型',
  align: 'center',
  dataIndex: 'category_dictText'
}, {
  title: '事件时间',
  align: 'center',
  dataIndex: 'logTime',
  sorter: true
}, {
  title: '备注',
  align: 'center',
  dataIndex: 'remark'
}];
var factorData = [];
var paramData = [];
var partData = [];
var productData = [];
var logData = [];
var stateData = [];
export default {
  name: 'ProductInfoModal',
  components: {
    LoadPrinting: LoadPrinting,
    IwsUpload: IwsUpload
  },
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '产品清单表单',
      tableName: 'ea_product_info',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 10
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 14
        }
      },
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 3
        }
      },
      wrapperCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 15
        }
      },
      url: {
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['imgDomainURL'],
        qrCodeServer: window._CONFIG['domianURL'] + '/sys/common/qrCode',
        carInfo: '/ea/product/car',
        chemicalInfo: '/ea/product/chemical',
        equipmentInfo: '/ea/product/equipment',
        instrumentInfo: '/ea/product/instrument',
        referenceInfo: '/ea/product/reference',
        productInfo: '/ea/product/info',
        queryCompany: '/ea/company/info/queryCompanyName'
      },
      urlAsset: {
        carInfo: '/ea/asset/car',
        chemicalInfo: '/ea/asset/chemical',
        equipmentInfo: '/ea/asset/equipment',
        attachmentInfo: '/ea/asset/attachment',
        assetInfo: '/ea/asset/info'
      },
      paramColumns: paramColumns,
      logColumns: logColumns,
      partColumns: partColumns,
      factorColumns: factorColumns,
      productColumns: productColumns,
      stateColumns: stateColumns,
      factorData: factorData,
      logData: logData,
      paramData: paramData,
      partData: partData,
      productData: productData,
      stateData: stateData,
      headers: {},
      picUrl: '',
      uploadLoading: false,
      category: '',
      companyList: [],
      infourl: '',
      assetUrl: '',
      factorOptions: [],
      product: {},
      asset: {},
      productList: [],
      tabsTitle: '配方成分'
    };
  },
  props: ['pagePath'],
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    };
  },
  computed: {
    uploadAction: function uploadAction() {
      return this.url.fileUpload;
    }
  },
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.model.category = this.category;
      this.loadProductList(); //加载产品

      this.loadFactor(); //确定需要展示的属性以及后台请求路径

      this.infourl = this.pagePath;
      this.assetUrl = this.urlAsset.assetInfo;

      if (this.category == 11) {
        this.infourl = this.url.equipmentInfo;
        this.assetUrl = this.urlAsset.equipmentInfo;
      } else if (this.category == 12) {
        this.infourl = this.url.instrumentInfo;
      } else if (this.category == 21 || this.category == 22 || this.category == 23) {
        this.infourl = this.url.chemicalInfo;
        this.assetUrl = this.urlAsset.chemicalInfo;

        if (this.category == 23) {
          this.infourl = this.url.referenceInfo;
        }
      } else if (this.category == 91 || this.category == 92) {
        this.infourl = this.url.productInfo;
        this.assetUrl = this.urlAsset.attachmentInfo;
      } else if (this.category == 31) {
        this.assetUrl = this.urlAsset.carInfo;
        this.infourl = this.url.carInfo;
      }

      this.visible = true;
      this.tabsTitle = this.category != 12 ? '配方成分' : '仪表试剂'; //加载产品信息

      this.loadAsset();
    },
    loadFactor: function loadFactor() {
      var _this = this;

      // 获取所有监测因子
      var paramsOne = {
        pageNo: 1,
        pageSize: 10000,
        status: 1
      };
      queryFactorList(paramsOne).then(function (res) {
        if (res.success) {
          _this.factorOptions = res.result.records;

          _this.loadProduct();
        }
      });
    },
    loadProduct: function loadProduct() {
      var _this2 = this;

      getAction(this.infourl + '/' + this.model.productId).then(function (res) {
        if (res.success) {
          _this2.product = Object.assign({}, res.result);
          _this2.product.factorName = '';
          var that = _this2;

          if (_this2.product.factorId && _this2.product.factorId != null) {
            var factor = _this2.factorOptions.filter(function (item) {
              return item.id == that.product.factorId;
            });

            _this2.product.factorName = factor && factor != [] ? factor[0].title + '(' + factor[0].code + ')' : '';
          }

          _this2.partData = _this2.product.parts;
          _this2.paramData = _this2.product.params;
          _this2.factorData = res.result.factors;
          _this2.productData = res.result.relateds;
          _this2.stateData = _this2.product.states;
        }
      });
    },
    loadProductList: function loadProductList() {
      var _this3 = this;

      var paramsOne = {
        pageNo: 1,
        pageSize: 10000,
        status: 1
      };
      getAction(this.url.productInfo, paramsOne).then(function (res) {
        if (res.success) {
          _this3.productList = res.result.records;
        }
      });
    },
    loadAsset: function loadAsset() {
      var _this4 = this;

      getAction(this.assetUrl + '/' + this.model.id).then(function (res) {
        if (res.success) {
          _this4.asset = Object.assign({}, res.result);
          _this4.logData = res.result.logs;
        }
      });
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      } //TODO 验证文件大小

    },
    productTabChange: function productTabChange(key) {
      if (key == 3) this.$refs.iwuploads.loadUploadFiles();
    },
    assetTabChange: function assetTabChange(key) {
      if (key == 2) this.$refs.iwupload.loadUploadFiles();
    },
    getAvatarView: function getAvatarView() {
      return this.url.imgerver + '/' + this.product.photo;
    },
    getQrCodeView: function getQrCodeView() {
      return this.url.qrCodeServer + '/' + this.asset.assetCode;
    },
    printing: function printing() {
      var record = this.asset;
      record.productName = this.product.name;
      record.modal = this.product.model;
      record.paramList = this.paramData;
      record.category = this.category;

      if (this.category == 21 || this.category == 22 || this.category == 23) {
        record.danger_dictText = this.product.danger_dictText;
        record.type_dictText = this.product.type_dictText;
      }

      this.$refs.LoadPrintingModal.detail(record);
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};